var map = {
	"./brand/reduced": 203,
	"./brand/reduced.svg": 203,
	"./brand/regular": 204,
	"./brand/regular.svg": 204,
	"./favicons/favicon-16x16": 205,
	"./favicons/favicon-16x16.png": 205,
	"./favicons/favicon-32x32": 206,
	"./favicons/favicon-32x32.png": 206,
	"./favicons/favicon-96x96": 207,
	"./favicons/favicon-96x96.png": 207,
	"./menu/event_logo": 208,
	"./menu/event_logo.png": 208,
	"./menu/logo": 209,
	"./menu/logo.svg": 209,
	"./menu/user": 210,
	"./menu/user.svg": 210,
	"./spinner": 211,
	"./spinner.svg": 211
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 214;